import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import HeaderFive from '../../components/Header/HeaderFive';
import BlogDetailsMain from './BlogDetailsMain';
import Footer from '../../components/Footer';
import FooterThree from '../../components/Footer/FooterThree';

const BlogDetails = () => {
  return (
    <>
      <HeaderFive />

      <BlogDetailsMain />

      <FooterThree />
    </>
  );
};

export default BlogDetails;
